<script>
import { globalVariablesMixin } from '../../../Mixins/global'
import mixinComponent from '../../../Mixins/mixinComponent'
import { isAdmin } from '../../../Utils'
import { isTheme } from '../../../Utils/isTheme'
import DataTable from '../../UI/Table/DataTable.vue'

export default {
  components: { DataTable },
  mixins: [mixinComponent, globalVariablesMixin],
  props: {
    selectedContractIds: {
      type: Array,
      default: [],
    },
    onlySelected: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:selectedContractIds'],
  data: (vm) => ({
    selection: vm.selectedContractIds,
  }),
  computed: {
    contractColumns() {
      return [
        {
          name: 'id',
          title: this.$t('restructuring.list.columns.select'),
          formatter: 'custom',
          sortable: false,
          options: {
            renderer: this.renderContractSelectionCell,
          },
        },
        { name: 'clientId', displayable: false },
        { name: 'supplierId', displayable: false },
        { name: 'platformId', displayable: false },
        { name: 'accountCodeSupplier', displayable: false },
        {
          name: 'createdAt',
          title: this.$t('contract.list.table.labelCreatedAt'),
          formatter: 'date',
        },
        {
          name: 'number',
          title: this.$t('contract.list.table.labelNumber'),
          formatter: 'context',
          options: { renderType: 'contracts', renderId: 'id' },
        },
        {
          name: 'agreementNumber',
          title: this.$t('contract.list.table.demandNumber'),
          style: { className: 'col-align-center' },
          displayable: isTheme('financia'),
        },
        {
          name: 'accountCodeClient',
          title: this.$t('contract.list.table.accountCodeClient'),
          displayable: isTheme('ciscar'),
        },
        {
          name: 'clientInfo',
          title: this.$t('main.client'),
        },
        {
          name: 'supplierInfo',
          title: this.$t('main.supplier'),
          displayable: isAdmin(),
        },
        {
          name: 'platformName',
          title: this.$t('contract.list.table.platformName'),
          displayable: !isTheme('financia'),
        },
        { name: 'companySalesmanName', title: this.$t('contract.list.table.companySalesmanName') },
        { name: 'platformSalesman', title: this.$t('contract.list.table.labelPlatformSalesman') },
        {
          name: 'rentMonthly',
          title: this.$t('contract.list.table.labelRentMonthly'),
          type: 'num-fmt',
          displayable: !isTheme('ciscar'),
          formatter: 'currency',
          style: { width: '60px;' },
        },
        {
          name: 'amount',
          title: this.$t('contract.list.table.labelTotalAmount'),
          type: 'num-fmt',
          displayable: !isTheme('ciscar'),
          formatter: 'currency',
          style: { width: '60px;' },
        },
        {
          name: 'rentAmount',
          title: this.$t('contract.list.table.labelRentAmount'),
          displayable: isTheme('ciscar'),
          formatter: 'currency',
          style: { width: '60px;' },
        },
        {
          name: 'status',
          title: this.$t('contract.list.table.labelStatus'),
          formatter: 'status',
          options: { renderType: 'contract' },
          style: { width: '120px;', className: 'text-center' },
        },
        {
          name: 'startAt',
          title: this.$t('contract.list.table.startAt'),
          formatter: 'date',
          displayable: isTheme('financia'),
        },
        {
          name: 'endAt',
          title: this.$t('contract.list.table.endAt'),
          formatter: 'date',
          displayable: isTheme('financia'),
        },
        { name: 'paidAt', title: this.$t('contract.list.table.labelPaidAt'), formatter: 'date' },
        {
          name: 'esign',
          title: this.$t('contract.list.table.esign'),
          formatter: 'boolean',
          displayable: isTheme('ciscar', 'olinn', 'financia'),
          options: { render: '' },
          style: { width: '60px;' },
        },
        {
          name: 'deliveryLabel',
          title: this.$t('contract.list.table.labelDeliveryAddress'),
          displayable: isTheme('ciscar'),
          style: { width: '120px;' },
        },
        {
          name: 'refinancerName',
          title: this.$t('contract.list.table.refinancerName'),
          displayable: isTheme('ciscar', 'olinn', 'financia'),
          style: { width: '120px;' },
        },
      ]
    },
    contractOrder() {
      return [[5, 'desc']]
    },
    additionalTableOptions() {
      return {
        createdRow: this.toggleSelectedRowClass,
      }
    },
  },
  methods: {
    async fetchContracts(callback, { page, limit, search, sort = [] }) {
      const searchParams = new URLSearchParams()
      searchParams.set('page', page)
      searchParams.set('limit', limit)
      for (let { field, order } of sort) {
        searchParams.set(`sort[${field}]`, order)
      }

      if (!!search) {
        searchParams.set('q', search)
      }

      searchParams.set('status', 'PAID-FINISH-PROLONGATION-CESSION')
      if (this.onlySelected) {
        for (const id of this.selectedContractIds) {
          searchParams.append('idList[]', id)
        }
      }

      const { items: contracts, total } = await this.getJSON('v2/contracts?' + searchParams.toString())

      callback({ data: contracts, recordsTotal: total, recordsFiltered: total })
    },
    renderContractSelectionCell(data) {
      const iconClass = this.selectedContractIds.includes(data) ? 'fa-minus' : 'fa-plus'

      return `<button type="button" class="btn" data-selector data-id="${data}"><i class="fas ${iconClass}"></i></button>`
    },
    toggleContractSelection(contractId) {
      if (this.selection.includes(contractId)) {
        this.selection = this.selection.filter((id) => id !== contractId)
      } else {
        this.selection.push(contractId)
      }
    },
    reload() {
      this.$refs.restructuringContractList.renderDataTable()
    },
    toggleSelectedRowClass(row, { id }) {
      if (this.selection.includes(id)) {
        row.classList.add('table-info')
      } else {
        row.classList.remove('table-info')
      }
    },
  },
  mounted() {
    $(document).on(
      'click.restructuring-contract-list-selection',
      '#restructuringContractList [data-selector]',
      (event) => {
        const contractId = parseInt(event.currentTarget.dataset.id)
        this.toggleContractSelection(contractId)
        this.toggleSelectedRowClass($(event.currentTarget).closest('tr').get(0), {
          id: contractId,
        })

        $(event.currentTarget)
          .find('i.fas') // 💩 but simple to do it
          .toggleClass('fa-plus')
          .toggleClass('fa-minus')
      },
    )
  },
  unmounted() {
    $(document).off('click.restructuring-contract-list-selection')
  },
  watch: {
    selection() {
      this.$emit('update:selectedContractIds', this.selection)
    },
    onlySelected() {
      this.reload()
    },
  },
}
</script>
<template>
  <DataTable
    id="restructuringContractList"
    ref="restructuringContractList"
    :columns="contractColumns"
    :order="contractOrder"
    :options="additionalTableOptions"
    :page-length="10"
    :fetch="fetchContracts"
    pagination-mode="server"
  />
</template>
